import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumbs from '../components/Breadcrumbs';
export default class Page extends Component {
  render() {
    return (
      <Fragment>
        <title>PropertyHints: 404 page not found</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <h1>No Page here</h1>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FourOhFour.jsx